import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/trigger/')({
  beforeLoad: () => {
    throw redirect({ to: '/runs' })
  },
})
